import { getClient } from './client';
import { API_URL } from './apiDictionary';
import {
  ReaderTasksFilters,
  Reading,
} from '@dynamika-shared/types/readings.types';
import { PaginatedResponse } from '@dynamika-shared/types/general';

export const fetchViewerTasks = (
  clinicalTrialId: string,
  filters: Partial<ReaderTasksFilters>,
  page?: number,
  size?: number
) => {
  const api = getClient(API_URL.viewerTasks);

  return api.get<PaginatedResponse<Reading>>(API_URL.viewerTasks, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
    params: {
      page: page ? page - 1 : 0,
      size: size ?? 10,
      ...filters,
    },
    id: 'viewer-tasks',
  });
};
